import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteDialog } from 'app/components/dialogs/DeleteDialog';
import { useNotificationsContext } from 'context';
import { ErrorNotification } from 'app/components/Notifications';
import { IOperatorDetails } from 'types/IEquipmentEntry';
import { EllipsisMenu } from 'app/components/menu/components/EllipsisMenu';
import { invitationsApi } from 'services/api/invitations/queries';

interface IRevokeAllAccessAction {
  userEmail: string;
  userName: string;
  sharedItems: IOperatorDetails[];
}

const RevokeAllAccessAction: React.FC<IRevokeAllAccessAction> = ({
  userEmail,
  sharedItems,
}) => {
  const { t } = useTranslation();
  const { addNotification, addSnackbar } = useNotificationsContext();
  const [revokeInvitation] = invitationsApi.useRevokeInvitationMutation();
  const [isRevokeAllAccessDialogOpen, setIsRevokeAllAccessDialogOpen] =
    useState(false);

  const handleRevokeAllAccess = async () => {
    try {
      const revokeRequests = sharedItems.map(item => ({
        shareType: item.type,
        exposedAccessSharingRecordId: item.exposedAccessSharingRecordId,
      }));

      if (revokeRequests.length === 0) return;

      await revokeInvitation(revokeRequests).unwrap();

      addSnackbar(
        <div className="snackbar-container">
          <span>
            {t('access_sharing.snackbars.you_removed_all_users_access')}
          </span>
        </div>,
      );
    } catch (error) {
      console.error(error);
      addNotification(<ErrorNotification text={t('server_error_message')} />);
    } finally {
      setIsRevokeAllAccessDialogOpen(false);
    }
  };

  return (
    <>
      <DeleteDialog
        open={isRevokeAllAccessDialogOpen}
        title={t(
          'access_sharing.shared_with.actions.revoke_all_access_confirmation',
          {
            email: userEmail,
          },
        )}
        confirmationLabel={t('access_sharing.role_based_actions.revoke')}
        onClose={() => setIsRevokeAllAccessDialogOpen(false)}
        onConfirm={handleRevokeAllAccess}
      />
      <EllipsisMenu
        actions={[
          {
            label: t('access_sharing.shared_with.actions.revoke_all_access'),
            action: () => setIsRevokeAllAccessDialogOpen(true),
          },
        ]}
      />
    </>
  );
};

export default RevokeAllAccessAction;
